import { display } from "redux-react/reducers/snackBarReducer";
import { api } from "./api";

const actions = {
	// Train a list of knowledges
	trainKnowledges: (uuid, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/knowledge/train`,
					data: {
						uuid
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: "Erreur lors de l'entrainement des connaissances"
							})
						);
					}
				})
			);
		};
	},
	// Train all knowledges that are not trained
	trainAllKnowledges: onSuccess => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/knowledge/train/all`,
					data: {},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: "Erreur lors de l'entrainement des connaissances"
							})
						);
					}
				})
			);
		};
	},
	// Train all knowledges from a source
	trainAllKnowledgesFromSources: (sources, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/knowledge/train/sources`,
					data: {
						sources
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: "Erreur lors de l'entrainement des connaissances"
							})
						);
					}
				})
			);
		};
	},
	/* Get knowledges by sources code */
	getKnowledgesBySourceCode: (code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v1/knowledge/source`,
					data: {
						code
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Update a knowledge */
	updateKnowledge: (code, update, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/faiq/api/v1/knowledge/update`,
					data: {
						code,
						update
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Create a knowledge */
	createKnowledge: (data, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/knowledge/create`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Delete a knowledge */
	deleteKnowledge: (uuid, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/faiq/api/v1/knowledge/delete`,
					data: {
						uuid
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Create a knowledge */
	mergeKnowledges: (uuids, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/knowledge/merge`,
					data: {
						uuids
					},
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
